import type { IntervalUnit } from '../../types';

type UnitLabelStrings = {
    CYCLES_UNIT: string;
    UNIT_FLIGHTS_LOWER: string;
    UNIT_HOURS_SHORT: string;
};

// Short usage-unit suffixes ("cycles", "flights", "h") keyed by interval unit —
// the single map behind every inline usage readout on the page.
export const getUnitLabels = (strings: UnitLabelStrings): Record<IntervalUnit, string> => ({
    cycles: strings.CYCLES_UNIT,
    flights: strings.UNIT_FLIGHTS_LOWER,
    hours: strings.UNIT_HOURS_SHORT
});
